export const useStoreDancer = defineStore('StoreDancer', {
    state: () => ({
        dancer: null,
        videos: null,
        error: null,
    }),
    actions: {
        async getDancer(dancerSlug) {
            this.error = null;
            this.dancer = null;
            let responses = await Promise.all([useEntityDancer().get(dancerSlug), this.getVideos(dancerSlug)]);
            this.dancer = responses[0]?.dancer;
            this.error = responses[0]?.error;
        },
        async getVideos(dancerSlug) {
            this.error = null;
            const filter = {
                paginate: {
                    auto: false,
                },
                fields: {
                    dancer_slug: dancerSlug,
                },
                order: [
                    {field: 'video_date_taken', asc: false},
                    {field: 'video_division', asc: true},
                    {field: 'video_format', asc: true},
                    {field: 'video_placing', asc: true},
                    {field: 'id_dancer', asc: false},
                    {field: 'video_title', asc: true},
                ],
            };
            ({videos: this.videos} = await useQueryVideos().get(filter));
        },
    },
});
